import { Button } from '@atlas/ui-primitives'
import { RefreshCw } from 'lucide-react'
import { Restricted } from '@/lib/refusal'

export interface RefreshFromWorkfrontButtonProps {
	/** True while the run is going: the label says so and the button takes no second press. */
	isRefreshing: boolean
	/** True after the API refused the run with a 409 (already syncing, or on-demand sync off). */
	alreadySyncing: boolean
	/** The reason shown while `alreadySyncing`: the server's message. */
	alreadySyncingReason: string
	onRefresh: () => void
}

/**
 * **Refresh from Workfront**: asks for the order's bundle now instead of at the next sync.
 * While another sync of the bundle runs it stays on screen, dimmed, with the reason on hover,
 * focus and press, so the reader learns why rather than finding a dead button.
 */
export function RefreshFromWorkfrontButton({
	isRefreshing,
	alreadySyncing,
	alreadySyncingReason,
	onRefresh,
}: RefreshFromWorkfrontButtonProps) {
	return (
		<Restricted allowed={!alreadySyncing} why={alreadySyncingReason}>
			<Button variant="secondary" className="rounded-ds-full" onPress={onRefresh} isDisabled={isRefreshing}>
				<RefreshCw className={isRefreshing ? 'h-4 w-4 animate-spin' : 'h-4 w-4'} aria-hidden />
				{isRefreshing ? 'Refreshing…' : 'Refresh from Workfront'}
			</Button>
		</Restricted>
	)
}
